import React from "react";

import { Switch, SwitchProps } from "@mui/material";

//Paar kleine aanpassingen in de standard switch om hem makkelijker te implementeren in Jamezz admin
//Als de checkbox niet gezet is wordt er een hidden value bij gezet
//Dit om dat je dan makkelijker in laravel mass assigment op 0 / false te kunnen zetten

export type NonsenseBoolean = boolean | (0 | 1) | ("0" | "1");

function CustomSwitch(props: {
  checked: NonsenseBoolean;
  name: string;
  disabled?: boolean;
  color?: SwitchProps["color"];

  onChange: (
    event: {
      target: { checked: NonsenseBoolean; value: NonsenseBoolean };
    },
    val: NonsenseBoolean
  ) => void;
}) {
  const { disabled = false, color = "primary" } = props;

  // De Switch component wilt als checked value een boolean hebben.
  // 99% van de keer komt er uit de database 0/1 terug
  const convertChecked = (checked: number | string | boolean) => {
    if (typeof checked === "number") {
      return checked === 1;
    }

    if (typeof checked === "string") {
      return checked === "1";
    }

    return checked;
  };

  return (
    <Switch
      checked={convertChecked(props.checked)}
      color={color}
      disabled={disabled}
      id={props.name}
      inputProps={{
        name: props.name,
        disabled: props.disabled,
      }}
      key={"switch"}
      onChange={(e, checked) => {
        console.log(checked);
        let returnChecked: NonsenseBoolean = checked;
        if (typeof props.checked === "number") {
          returnChecked = checked ? 1 : 0;
        } else if (typeof props.checked === "string") {
          returnChecked = checked ? "1" : "0";
        }
        props.onChange({ target: { checked: returnChecked, value: returnChecked } }, returnChecked);
      }}
      value={convertChecked(props.checked) ? 1 : 0}
    />
  );
}

export default CustomSwitch;
